import { render, staticRenderFns } from "./ExamineeTest.vue?vue&type=template&id=ed0316f8&scoped=true&"
import script from "./ExamineeTest.vue?vue&type=script&lang=js&"
export * from "./ExamineeTest.vue?vue&type=script&lang=js&"
import style0 from "./ExamineeTest.vue?vue&type=style&index=0&id=ed0316f8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0316f8",
  null
  
)

export default component.exports